//  import React from 'react';

// const Nlpsolution = () => {
//   return (
//     <div className="nlp-container">
//       <div className="text-section">
//         <h2 className="title">Revolutionizing Communication</h2>
//         <p className="description">
//           Delivering intelligent NLP solutions for seamless interaction.
//         </p>
//         <p className="description">
//           Natural Language Processing (NLP) is the core of human-computer interaction. From voice commands to text analysis, NLP empowers businesses to derive actionable insights from language data.
//         </p>
//         <p className="description">
//           Our expert team leverages cutting-edge techniques, including machine learning, deep learning, and semantic analysis, to create solutions tailored to your needs.
//         </p>
//         <p className="description">
//           Whether it's sentiment analysis, chatbot development, or speech recognition, we transform language into a strategic asset for your business growth.
//         </p>
//       </div>

//       <div className="image-section">
//         <img
//           src="/image/nlp-details-1.webp"
//           alt="AI Solutions"
//           className="image"
//         />
//       </div>

//       {/* Responsive CSS */}
//       <style jsx>{`
//         .nlp-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 20px;
//           background-color: white;
//           box-sizing: border-box;
//           min-height: 70vh;
//           flex-wrap: wrap;
//         }

//         .text-section {
//           width: 45%;
//           padding-right: 20px;
//           text-align: left;
//         }

//         .title {
//           font-size: 32px;
//           font-weight: bold;
//           margin-bottom: 20px;
//           color: black;
//         }

//         .description {
//           font-size: 16px;
//           line-height: 1.6;
//           margin-bottom: 15px;
//           text-align: justify;
//           color: black;
//         }

//         .image-section {
//           width: 45%;
//           text-align: center;
//         }

//         .image {
//           width: 100%;
//           max-width: 400px;
//           height: auto;
//           border-radius: 8px;
//           box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//         }

//         /* Tablet view */
//         @media screen and (max-width: 1024px) {
//           .text-section,
//           .image-section {
//             width: 100%;
//             padding-right: 0;
//             text-align: center;
//           }

//           .title {
//             font-size: 28px;
//           }

//           .description {
//             font-size: 15px;
//           }
//         }

//         /* Mobile view */
//         @media screen and (max-width: 768px) {
//           .nlp-container {
//             flex-direction: column;
//             text-align: center;
//           }

//           .text-section {
//             width: 100%;
//             margin-bottom: 20px;
//           }

//           .image-section {
//             width: 100%;
//           }

//           .title {
//             font-size: 24px;
//           }

//           .description {
//             font-size: 14px;
//           }

//           .image {
//             max-width: 90%;
//           }
//         }

//         /* Small Mobile */
//         @media screen and (max-width: 480px) {
//           .title {
//             font-size: 20px;
//           }
//           .description {
//             font-size: 13px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Nlpsolution;




import React, { useEffect, useRef } from 'react';

const Nlpsolution = () => {
  const textSectionRef = useRef(null);
  const imageSectionRef = useRef(null);

  useEffect(() => {
    const textSection = textSectionRef.current;
    const imageSection = imageSectionRef.current;

    // Create Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animation classes when element is in view
            if (entry.target === textSection) {
              entry.target.classList.add('animate-text');
            } else if (entry.target === imageSection) {
              entry.target.classList.add('animate-image');
            }
            
            // Unobserve after animation to prevent re-triggering
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 } // Trigger when 20% of element is visible
    );

    // Observe both sections
    if (textSection) observer.observe(textSection);
    if (imageSection) observer.observe(imageSection);

    // Cleanup
    return () => {
      if (textSection) observer.unobserve(textSection);
      if (imageSection) observer.unobserve(imageSection);
    };
  }, []);

  return (
    <div className="nlp-container">
      <div className="text-section" ref={textSectionRef}>
        <h2 className="title">Revolutionizing Communication</h2>
        <p className="description">
          Delivering intelligent NLP solutions for seamless interaction.
        </p>
        <p className="description">
          Natural Language Processing (NLP) is the core of human-computer interaction. From voice commands to text analysis, NLP empowers businesses to derive actionable insights from language data.
        </p>
        <p className="description">
          Our expert team leverages cutting-edge techniques, including machine learning, deep learning, and semantic analysis, to create solutions tailored to your needs.
        </p>
        <p className="description">
          Whether it's sentiment analysis, chatbot development, or speech recognition, we transform language into a strategic asset for your business growth.
        </p>
      </div>

      <div className="image-section" ref={imageSectionRef}>
        <img
          src="/image/nlp-details-1.webp"
          alt="AI Solutions"
          className="image"
        />
      </div>

      {/* Responsive CSS */}
      <style jsx>{`
        .nlp-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          background-color: white;
          box-sizing: border-box;
          min-height: 70vh;
          flex-wrap: wrap;
        }

        .text-section {
          width: 45%;
          padding-right: 20px;
          text-align: left;
          opacity: 0;
          transform: translateY(50px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }

        .text-section.animate-text {
          opacity: 1;
          transform: translateY(0);
        }

        .image-section {
          width: 45%;
          text-align: center;
          opacity: 0;
          transform: translateX(-50px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }

        .image-section.animate-image {
          opacity: 1;
          transform: translateX(0);
        }

        .title {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 20px;
          color: black;
        }

        .description {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 15px;
          text-align: justify;
          color: black;
        }

        .image {
          width: 100%;
          max-width: 400px;
          height: auto;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        /* Tablet view */
        @media screen and (max-width: 1024px) {
          .text-section,
          .image-section {
            width: 100%;
            padding-right: 0;
            text-align: center;
          }

          .title {
            font-size: 28px;
          }

          .description {
            font-size: 15px;
          }
        }

        /* Mobile view */
        @media screen and (max-width: 768px) {
          .nlp-container {
            flex-direction: column;
            text-align: center;
          }

          .text-section {
            width: 100%;
            margin-bottom: 20px;
          }

          .image-section {
            width: 100%;
          }

          .title {
            font-size: 24px;
          }

          .description {
            font-size: 14px;
          }

          .image {
            max-width: 90%;
          }
        }

        /* Small Mobile */
        @media screen and (max-width: 480px) {
          .title {
            font-size: 20px;
          }
          .description {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default Nlpsolution;